// extracted by css-extract-rspack-plugin
export default {"cls1":"SingularMentionCitationModal-cls1_iVp","cls2":"SingularMentionCitationModal-cls2_Dl7 SingularMentionCitationModal-cls1_iVp"};